import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SEOPageTitle from 'components/shared/SEOPageTitle';
import PillTabs from 'components/shared/tabs/PillTabs';
import CouponList from 'components/admin-coupons/CouponList';
import CouponMetrics from 'components/admin-coupons/CouponMetrics';
import AppBarContext from 'context/AppBarContext';

/**
 * Panel admin de cupones, con tabs Cupones | Métricas (patrón ClientPaymentList).
 */
function CouponsAdminPage() {
  const { t } = useTranslation(['coupons', 'routes']);
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);
  const [tab, setTab] = useState(0);
  const pageTitle = t('coupons', { ns: 'routes', defaultValue: 'Cupones' });

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(pageTitle);
  }, [pageTitle, setAppBarButton, setAppBarTitle]);

  return (
    <>
      <SEOPageTitle title={pageTitle} />
      <PillTabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        ariaLabel={pageTitle}
        sx={{ mb: 2.5 }}
        tabs={[
          { key: 'list', label: t('couponsTab', { ns: 'coupons', defaultValue: 'Cupones' }) },
          { key: 'metrics', label: t('metricsTab', { ns: 'coupons', defaultValue: 'Métricas' }) }
        ]}
      />
      {tab === 0 ? <CouponList /> : <CouponMetrics />}
    </>
  );
}

export default CouponsAdminPage;
